import * as actions from "./actions";
import { initialState } from "../reducer";
import _ from "underscore";

export function factoringSubreducer(state = initialState, action) {
  switch (action.type) {
    case actions.FACTORING_CREATE_REQUEST:
      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          applicationCreate: Object.assign(
            {},
            state.factoring.applicationCreate,
            {
              sent: false,
              sending: true,
            },
          ),
        }),
      });
    case actions.FACTORING_CREATE_SUCCESS:
      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          applicationCreate: Object.assign(
            {},
            state.factoring.applicationCreate,
            {
              sent: true,
              sending: false,
              error: null,
            },
          ),
        }),
      });
    case actions.FACTORING_CREATE_ERROR:
      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          applicationCreate: Object.assign(
            {},
            state.factoring.applicationCreate,
            {
              sent: false,
              sending: false,
              error: action.error,
            },
          ),
        }),
      });
    // Fetching of data
    case actions.GET_FACTORING_APPLICATIONS_REQUEST:
      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          application: Object.assign({}, state.factoring.application, {
            fetching: true,
            error: null,
            data: [],
          }),
        }),
      });
    case actions.GET_FACTORING_APPLICATIONS_SUCCESS:
      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          application: Object.assign({}, state.factoring.application, {
            fetching: false,
            error: null,
            data: action.response,
          }),
        }),
      });
    case actions.GET_FACTORING_APPLICATIONS_ERROR:
      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          application: Object.assign({}, state.factoring.application, {
            fetching: false,
            error: action.error,
          }),
        }),
      });
    // Fetching of details data
    case actions.GET_FACTORING_INVOICE_REQUEST:
      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          invoice: Object.assign({}, state.factoring.invoice, {
            fetching: true,
          }),
        }),
      });
    case actions.GET_FACTORING_INVOICE_SUCCESS:
      var data = Array.isArray(action.response)
        ? action.response
        : [action.response];

      data[0].fee = {
        sending: false,
        sent: false,
        error: null,
      };

      data = [...state.factoring.invoice.data, ...data];
      data = _.uniq(data, (item) => {
        return item.Id;
      });

      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          invoice: Object.assign({}, state.factoring.invoice, {
            fetching: false,
            data: data,
            error: null,
          }),
        }),
      });
    case actions.GET_FACTORING_INVOICE_ERROR:
      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          invoice: Object.assign({}, state.factoring.invoice, {
            fetching: false,
            error: action.error,
          }),
        }),
      });
    // Other
    case actions.FACTORING_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          application: Object.assign({}, state.factoring.application, {
            table: Object.assign({}, state.factoring.application.table, {
              pagination: Object.assign(
                {},
                state.factoring.application.table.pagination,
                {
                  page: action.page,
                },
              ),
            }),
          }),
        }),
      });
    case actions.FACTORING_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          application: Object.assign({}, state.factoring.application, {
            table: Object.assign({}, state.factoring.application.table, {
              currentFilter: Object.assign(
                {},
                state.factoring.application.table.currentFilter,
                {
                  ...action.filter,
                },
              ),
            }),
          }),
        }),
      });
    case actions.FACTORING_ADD_INVOICE_FEE_REQUEST:
      var invoiceAddFeeRequestData = state.factoring.invoice.data.map(
        (item) => {
          if (item.Id !== action.dataSent.InvoiceId) return item;
          else
            return {
              ...item,
              fee: Object.assign({}, item.fee, {
                sending: true,
                sent: false,
                error: null,
              }),
            };
        },
      );

      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          invoice: Object.assign({}, state.factoring.invoice, {
            data: invoiceAddFeeRequestData,
          }),
        }),
      });
    case actions.FACTORING_ADD_INVOICE_FEE_SUCCESS:
      var invoiceAddFeeSuccessData = state.factoring.invoice.data.map(
        (item) => {
          if (item.Id !== action.dataSent.InvoiceId) return item;
          else
            return {
              ...item,
              fee: Object.assign({}, item.fee, {
                sending: false,
                sent: true,
                error: null,
              }),
            };
        },
      );

      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          invoice: Object.assign({}, state.factoring.invoice, {
            data: invoiceAddFeeSuccessData,
          }),
        }),
      });
    case actions.FACTORING_ADD_INVOICE_FEE_ERROR:
      var invoiceAddFeeErrorData = state.factoring.invoice.data.map((item) => {
        if (item.Id !== action.dataSent.InvoiceId) return item;
        else
          return {
            ...item,
            fee: Object.assign({}, item.fee, {
              sending: false,
              sent: false,
              error: action.error,
            }),
          };
      });

      return Object.assign({}, state, {
        factoring: Object.assign({}, state.factoring, {
          invoice: Object.assign({}, state.factoring.invoice, {
            data: invoiceAddFeeErrorData,
          }),
        }),
      });
    default:
      return state;
  }
}
